const FORBIDDEN_KEYS = new Set(["__proto__", "constructor", "prototype"]);

export function setValueAtPath<T extends Record<string, unknown>>(
  obj: T,
  path: string,
  value: unknown,
): T {
  const keys = path.split(".");

  if (keys.some((key) => FORBIDDEN_KEYS.has(key))) {
    throw new Error(`Forbidden key in path: ${path}`);
  }

  const result = { ...obj };
  let current: Record<string, unknown> = result;

  for (let i = 0; i < keys.length - 1; i++) {
    const key = keys[i];
    if (current[key] && typeof current[key] === "object") {
      current[key] = { ...(current[key] as Record<string, unknown>) };
      current = current[key] as Record<string, unknown>;
    } else {
      current[key] = {};
      current = current[key] as Record<string, unknown>;
    }
  }

  const lastKey = keys[keys.length - 1];
  current[lastKey] = value;

  return result;
}
